module.exports = __webpack_public_path__ + "media/images/profiles/profile-2-758ccf7d388b8b419b4495f1f8485472.png";